interface PlanKeyValues {
  tokkun: string | null;
  basic: string | null;
}

interface RegistrationTrackerParams {
  efoVersion?: string;
  subset?: string | null;
  gradeCode?: string;
  learnUserId?: string;
}

class RegistrationTracker {
  private defaultLearnUserId: string | null;
  private defaultGradeCode: string | null;
  private defaultEFOVersion: string | null;
  private paymentSystemVersion: string | null;
  private context: string | null;
  private planPrices: PlanKeyValues | null;
  private priceId: string | null;

  constructor() {
    const params = document.getElementById('tracking-data-params');
    if (!params) {
      throw Error('#tracking-data-params does not exist!');
    }
    this.defaultLearnUserId = params.getAttribute('data-learn-user-id');
    this.defaultGradeCode = params.getAttribute('data-grade-code');
    this.defaultEFOVersion = params.getAttribute('data-default-efo-version');
    this.context = params.getAttribute('data-context');

    // data attributes には、null も文字列 "null" として入っている。JSON.parse で JSON の値か null にする。
    this.planPrices = JSON.parse(
      params.getAttribute('data-plan-prices') as string,
    );

    this.priceId = params.getAttribute('data-price-id') || null; // 既存の subscriptionCodes と互換性を保つために、存在しない場合は空文字でなく null を使う
    this.paymentSystemVersion = params.getAttribute(
      'data-payment-system-version',
    );
  }

  public track(step: number, params: RegistrationTrackerParams): void {
    const firebaseClient = (window as any).firebaseClient;

    const p: any = {
      step,
      signup_type: 'b2c',
      subset: params.subset,
      efo_version: params.efoVersion || this.defaultEFOVersion,
      grade_code: params.gradeCode || this.defaultGradeCode,
      context: this.context,
      charge_codes: null,
      payment_system_version: this.paymentSystemVersion,
    };

    // ref https://github.com/quipper/aya-issues/issues/84462#issuecomment-2470051366
    // plan_prices、subscription_codes、charge_codes は、SBPS 決済基盤では null で送ることにした。
    // JSON は JSON.stringify で文字列に変換する。JSON のまま渡すと Firebase へ送信時に文字列の `[object Object]` となる。
    // データ分析チームの都合上、Stripe基盤では subscription_codes をパラメータ名として priceId を送る。
    if (this.paymentSystemVersion === 'v2') {
      p.plan_prices =
        this.planPrices !== null ? JSON.stringify(this.planPrices) : null;
      p.subscription_codes = this.priceId;
    } else {
      p.plan_prices = null;
      p.subscription_codes = null;
    }

    const userId = params.learnUserId || this.defaultLearnUserId;

    firebaseClient?.trackEvent(userId, 'views_learn_signup_wizard', p);
  }
}

export default RegistrationTracker;
